import React from "react";
import "aos/dist/aos.css";
import ui from "../../assets/ui.png";
import web from "../../assets/web.png";
import design from "../../assets/design.webp";
import photography from "../../assets/photography.png";

const servicesData = [
  {
    title: "UI/UX Design",
    description:
      "Creating intuitive digital products that provide positive and efficient user experiences through modern research and design principles.",
    image: ui,
    color: "from-blue-500/20 to-cyan-500/20",
  },
  {
    title: "Web & Mobile Dev",
    description:
      "Full-stack development for cross-platform mobile apps and responsive web applications using the latest modern technologies.",
    image: web,
    color: "from-purple-500/20 to-indigo-500/20",
  },
  {
    title: "Graphic Design",
    description:
      "Compelling visuals that resonate with your target audience and effectively convey your brand's unique message.",
    image: design,
    color: "from-orange-500/20 to-pink-500/20",
  },
  {
    title: "Photography",
    description:
      "Professional photography to capture moments and visually represent your products or concepts with high emotional impact.",
    image: photography,
    color: "from-green-500/20 to-emerald-500/20",
  },
];

export default function Services() {
  return (
    <div className="w-full py-20 bg-gray-50/50" id="services">
      <div className="mx-5 lg:mx-20 flex flex-col gap-12">
        <div className="text-center" data-aos="fade-up">
          <h1 className="font-Poppins font-medium text-slate-400 uppercase tracking-[0.2em] text-sm">
            What I Offer
          </h1>
          <h2 className="text-3xl lg:text-4xl font-bold mt-2 text-[#131315] font-Poppins">
            Specialized Services
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {servicesData.map((service, index) => (
            <div
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 100}
              className="group relative bg-white p-8 m-3 rounded-3xl border border-gray-100 shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-500 overflow-hidden"
            >
              {/* Background Accent */}
              <div
                className={`absolute -right-10 -bottom-10 w-40 h-40 bg-gradient-to-br ${service.color} rounded-full blur-3xl group-hover:scale-150 transition-transform duration-700`}
              ></div>

              <div className="relative z-10 flex flex-col items-center text-center">
                <div className="w-20 h-20 mb-6 bg-gray-50 rounded-2xl flex items-center justify-center group-hover:bg-white group-hover:scale-110 transition-all duration-500 shadow-sm">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-12 h-12 object-contain"
                  />
                </div>

                <h3 className="font-Poppins font-bold text-xl text-[#3aa1ff] mb-4">
                  {service.title}
                </h3>

                <p className="text-gray-500 font-Inter text-sm leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
